<template lang="pug">
f7-page(:class="{ 'unset-scroll': showPopup && isInAppWeb }")#coach-detail
  transparent-navbar(v-if="scrollPosition < 404")
    template(v-slot:right)
      f7-link(@click="didTapShareCoach").back-page(share)
        svg-icon(icon="share")
  navbar(
    v-else
    :title="coachName"
    back
  )
    template(v-slot:right)
      f7-link(@click="didTapShareCoach")
        svg-icon.share(icon="share")

  //- bottom tool bar
  .apply-contract(v-if="isInAppWeb && status === 'NOT_APPLIED'" class="toolbar toolbar-bottom-md")
    .toolbar-inner
      large-multiline-button(
        title="この先生の無料体験レッスンを希望する"
        class="apply-contract-button"
        :disabled="!isAcceptableNewStudent"
        @click="goToApplication")
      p.text-warning(v-if="!isAcceptableNewStudent") 定員に達したため、新規受け入れをストップしています
      p(v-else) 先生の空き状況により、ご希望に添えない場合があります。

  //- page content
  coach-query(:coachId="coachId" @onResult="onResult")
    div(slot-scope="{ coach }")
      coach-detail-top(:coach="coach")

      coach-detail-body(:coach="coach" class="coach-detail-body" @click="showReview")
  encourage-application(
    v-if="showPopup && isInAppWeb && status === 'NOT_APPLIED'"
    @didTapApplication="goToApplication"
    @closePopup="closePopup"
    )
</template>

<style lang="scss">
.unset-scroll {
  .page-content {
    overflow: unset !important;
  }
}
</style>

<style lang="scss" scoped>
.toolbar {
  position: fixed;
}
.apply-contract {
  height: 100px !important;
  background: #101c2a;

  .toolbar-inner {
    flex-direction: column;
    justify-content: space-evenly;
    padding: 8px 24px;

    .text-warning {
      color: $color-notification;
    }
  }

  .apply-contract-button {
    width: 100%;
  }

  p {
    @extend %description;
    margin: 0;
  }
}

.coach-detail-body {
  padding-bottom: 92px !important;
  position: absolute;
  top: 460px;
  width: 100%;
}

.share {
  width: 23px;
  height: 23px;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

a.back-page.link {
  border-radius: 50%;
  background-color: rgba(22, 23, 26, 0.2);
  text-align: center;

  @media (max-width: 768px) {
    width: 50px;
    min-width: 50px !important;
    height: 50px;
    line-height: 40px;
  }
  @media (min-width: 768px) {
    width: 64px;
    display: inline-block;
  }

  .svg-icon {
    margin-left: auto;
    margin-right: auto;
    width: 24px;
    height: 40px;
    font-weight: bold;
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import BridgeSwift from '@/components/mixins/BridgeSwift'
import TransparentNavbar from '@/components/organisms/TransparentNavbar'
import CoachDetailTop from '@/components/organisms/CoachDetailTop'
import CoachDetailBody from '@/components/organisms/CoachDetailBody'
import LargeMultilineButton from '@/components/atoms/LargeMultilineButton'
import CoachQuery from '@/components/queries/CoachQuery'
import EncourageApplication from '@/components/organisms/EncourageApplication'

export default {
  components: {
    TransparentNavbar,
    CoachDetailTop,
    CoachDetailBody,
    LargeMultilineButton,
    CoachQuery,
    EncourageApplication,
  },
  mixins: [BridgeSwift],
  data() {
    return {
      coachId: null,
      coachName: null,
      appLoggedIn: false,
      isAcceptableNewStudent: false,
      scrollPosition: 0,
      showPopup: false,
    }
  },
  computed: {
    ...mapGetters('displayType', ['isInAppWeb']),
    ...mapGetters('pageInfo', ['coachVisitTime']),
    ...mapGetters('application', ['status']),
  },
  watch: {
    coachVisitTime() {
      // this.showPopup = this.coachVisitTime % 5 === 0
      this.showPopup = this.coachVisitTime === 1
    },
  },
  methods: {
    countCoachVisitTime() {
      if (this.isInAppWeb) {
        this.$store.dispatch('pageInfo/updateCoachVisitTime')
      }
    },
    closePopup() {
      this.showPopup = false
    },
    onResult(coach) {
      this.coachName = coach.name
      this.isAcceptableNewStudent = coach.isAcceptableNewStudent
    },
    goToSignUp() {
      this.postMessageToSwift('didTapIntroduceTeacher')
      this.$f7router.navigate({
        name: 'PublicSignUp',
      })
      this.closePopup()
    },
    goToApplication() {
      this.$f7router.navigate({
        name: 'PublicApplication',
      })
      this.closePopup()
    },
    showSignUp() {
      this.postMessageToSwift('didTapIntroduceTeacherWithCoachId', this.coachId)
      this.$f7router.navigate({
        name: 'PublicSignUp',
        params: { coachId: this.coachId },
      })
    },
    showReview(reviewId) {
      this.$f7router.navigate({
        name: 'PublicCoachReviews',
        params: { id: this.coachId, reviewId: reviewId },
      })
    },
    contentScrolled(position) {
      this.scrollPosition = position
    },
    didTapShareCoach() {
      let params = {
        coachPageUrl: `https://dance-media.spotomo.com/sdm_coach-${this.coachId.toLowerCase()}/`,
        coachName: this.coachName,
      }
      this.postMessageToSwift('didTapShareCoach', params)
    },
  },
  created() {
    this.coachId = this.$f7route.params.id
  },
  mounted() {
    this.countCoachVisitTime()
    this.postMessageToSwift('didShowCoachDetail', this.coachId)
    this.$f7.$('.page-content').on('scroll', (e) => {
      this.contentScrolled(e.srcElement.scrollTop)
    })
  },
}
</script>
